import { RevenueListWrapper } from './users-list/RevenueList'

const Detail = () => {
  return (
    <RevenueListWrapper /> 
  )
}

export {Detail}
